<template>
<v-dialog
  v-model='isPostDialogVisible'
  width="60%"
  persistent
  max-width='500px'
>
  <v-card>
    <v-card-title>
      Post new Bit
      <v-spacer></v-spacer>
      <v-btn
        icon
        color="light-blue accent-4"
        @click.stop="inspectClipboard()"
      >
      <v-icon
        small
        class="ml-1"
      >mdi-content-copy</v-icon>
      </v-btn>
    </v-card-title>

  <v-card-text>
    <v-textarea
      v-model="newPostText"
      auto-grow
      filled
      color="light-blue accent-4"
      label="Entry"
      rows="3"
    ></v-textarea>
  </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        text
        @click='closePostDialog'
      >Close</v-btn>

      <v-btn
        color="orange"
        dark
        @click='onPost'
      >POST</v-btn>
    </v-card-actions>

  </v-card>

</v-dialog>
</template>


<script>
import { mapActions } from 'vuex'


export default {
  name: 'CreatePost',
  computed: {
    // ...mapGetters({isPostDialogVisible: 'ui/isPostDialogVisible'}),
    isPostDialogVisible: {
      get() {
        return this.$store.getters['ui/isPostDialogVisible'];
      },
      set(value) {
        console.log(`isPostDialogVisible new value is: ${value}`)
        // this.$store.dispatch('ui/closeEditForm')
      }
    },

  },
  methods: {
    ...mapActions({
      postNewBit: 'postNewBit',
      closePostDialog: 'ui/closePostDialog',
    }),
    inspectClipboard () {
      navigator.clipboard.readText()
        .then(text => {
          console.log('clipboard content: ', text);
          this.newPostText = text;
        })
        .catch(err => {
          console.error('Failed to read clipboard content: ', err);
        });
    },
    onPost() {
      this.closePostDialog();
      var ret = this.postNewBit(this.newPostText);
      console.log(ret);

      console.log('resetting state..');
      this.newPostText = '';
    },
  },
  data: () => ({
    newPostText: '',
  })
}

</script>

